import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { util } from '../../util/util';
import { RestService } from './rest.service';
import { StockCountFilter } from 'app/core/store/stock-count/stock-count-filter.interface';
import {
  GetStockCountMaterialList,
  StockCountCreated,
  StockCountCreateOrderList,
  StockCountDetail,
  StockCountList,
  TOstockCount,
} from 'app/core/store/stock-count/stock-count.interface';

@Injectable({ providedIn: 'root' })
export class StockCountRestService {
  constructor(private restService: RestService) {
  }

  getStockCounts(filter: StockCountFilter): Observable<StockCountList> {
    if (filter) {
      const params = StockCountRestService.getQueryParamsForStockCounts({}, filter);
      return this.restService.get<any>(`/Stock/getStockCountList?${params}`);
    }
    return this.restService.get<any>('/Stock/getStockCountList');
  }

  getStockCountDetail(stockCountNumber: number): Observable<StockCountDetail> {
    if (stockCountNumber) {
      return this.restService.get<any>(`/Stock/getStockCount?StockCountNo=${stockCountNumber}`);
    }
  }

  getStockCountOrderList(shipto: number): Observable<StockCountCreateOrderList> {
    if (shipto) {
      return this.restService.get<any>(`/Stock/getOrders?ShipTo=${shipto}`);
    }
  }

  getStockCountMaterialList(materialList: GetStockCountMaterialList): Observable<{ materials: { packingID: string, amount: string }[] }> {
    if (materialList) {
      return this.restService.post<{ materials: { packingID: string; amount: string }[] }>(`/Stock/getMaterials`, materialList);
    }
    return of({materials: []});
  }

  getShipTos(customerId: string) {
    if (customerId) {
      return this.restService.get<any>(`/Stock/getStockCountLocations?CustomerNo=${customerId}`);
    }
    throw new Error('customer-ID is empty.  Can`t get shipTos.');
  }

  createStockCount(stockCounts: TOstockCount) {
    // TODO BFR: avoid double creation (same solution as for create orders/flows/relocations
    if (stockCounts) {
      return this.restService.post<StockCountCreated>(`/Stock/createStockCount`, this.trimOrders(stockCounts));
    }
  }

  printStockCount(shipto: string): Observable<Blob> {
    if (shipto) {
      return this.restService.getBlobData(`/Stock/printStockCount?ShipTo=${shipto}`);
    }
  }

  trimOrders(stockCounts: TOstockCount): TOstockCount {
    const trimmedOrders = stockCounts.order.filter(util.uniqFilterFn('etmOrderNo')).map(order => {
      return {
        etmOrderNo: order.etmOrderNo,
        salesOrderNo: order.salesOrderNo,
        includedInCount: order.includedInCount,
      };
    });

    const trimmedMaterials = stockCounts.item.map(i => {
      return {
        packingID: i.packingID,
        amount: i.countedAmount,
        notCounted: i.notCounted,
      };
    });

    return {
      ...stockCounts,
      order: trimmedOrders,
      item: trimmedMaterials,
    };
  }

  private static getQueryParamsForStockCounts(params: any, filter: StockCountFilter) {
    const newParamsObject = {
      ...params,
      ShipTo: filter.shipTos,
      StockCountDateFrom: filter.countDateFrom,
      StockCountDateTo: filter.countDateTo,
      StockCountNo: filter.registrationNumber,
      PageNumber: filter.pageNumber,
      PageSize: filter.pageSize,
      SortingColumn: filter.sortingColumn,
      SortingType: filter.sortingType,
    };
    return util.serializeObjectToParams(newParamsObject);
  }
}
